import { render, staticRenderFns } from "./DataSatImg.vue?vue&type=template&id=ebe311f6&"
import script from "./DataSatImg.vue?vue&type=script&lang=js&"
export * from "./DataSatImg.vue?vue&type=script&lang=js&"
import style0 from "./DataSatImg.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports